/* index-treats-logos-lists-marquee */
initMarquee('.index-treats-logos-lists-marquee', {
    mobile: {
        duration: 50000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 60000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});
/* index-treats-logos-lists-marquee */